module.exports = "/templates/users.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/users.html
// module id = 484
// module chunks = 0